import { render, staticRenderFns } from "./CRDFilesList.vue?vue&type=template&id=58b61a84&scoped=true&"
import script from "./CRDFilesList.vue?vue&type=script&lang=js&"
export * from "./CRDFilesList.vue?vue&type=script&lang=js&"
import style0 from "./CRDFilesList.vue?vue&type=style&index=0&id=58b61a84&lang=scss&scoped=true&"
import style1 from "./CRDFilesList.vue?vue&type=style&index=1&id=58b61a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b61a84",
  null
  
)

export default component.exports